export enum CameraStatus {
    NotFound = 0,
    FoundNotWithinTolerance = 1,
    Found = 2,
}

